/**
 * The ult-ready frame on the hotbar (docs/design/ui/2026-10-11-ground-aim/README.md): a move paid in rage (ท่าใหญ่) gets
 * `ult-ready` when the rage is there and it is off cooldown: a gold inner rim and four pixel corner ticks stepping out
 * and back twice a second (ult-ready.css). Not ready, the red frame stays but loses its glow, so "ready" reads at a glance.
 */
import type { Entity, SkillDef } from '@nine/shared';
import './ult-ready.css';

/** Sets `ult-ready` on each rage move's slot (only when it changes). */
export function syncUltReady(slots: readonly HTMLElement[], skills: readonly SkillDef[], p: Entity): void {
  skills.forEach((s, i) => {
    const b = slots[i];
    if (!b || !s.rage) return;
    const on = p.rage >= s.rage && (p.cooldowns[s.id] ?? 0) <= 0 && !p.dead;
    if (b.classList.contains('ult-ready') !== on) b.classList.toggle('ult-ready', on);
  });
}
